import CustomDomainErrorIcon from '@/assets/svg/custom-domain-error.svg?react';
import { CopyableText } from '@/components/copyable-text/CopyableText';
import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import { ErrorCode } from '@/shared/constant/error/ErrorCode';
import type { ErrorCodeMessageType } from '@/shared/constant/error/ErrorCodeMessageType';
import clsx from 'clsx';
import React from 'react';

export type CustomDomainErrorProps = {
  value: ErrorCodeMessageType;
  className?: string;
};

export function CustomDomainError(props: CustomDomainErrorProps) {
  const { value, className } = props;

  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);

  const customCnameList = React.useMemo(() => {
    if (value.errorCode !== ErrorCode.CustomDomainError) {
      return [];
    }

    return value.extra?.customCnameList ?? [];
  }, [value]);

  const [cname1 = '', cname2 = '', cnameX = ''] = customCnameList;

  return (
    <div
      className={clsx(
        'flex w-auto flex-col items-center justify-center max-os:p-5 os:w-[480px]',
        className,
      )}
    >
      <CustomDomainErrorIcon />

      <div className="align-center mt-8 flex justify-center text-center text-2xl font-semibold text-color">
        {clientI18n(customCnameList.length ? 'customDomain.error.tip' : 'customDomain.error.tip2')}
      </div>
      {!!customCnameList.length && (
        <div className="align-center mt-2 text-lg font-400 text-secondary">
          {IS_GLOBAL && (
            <>
              CNAME : <CopyableText text={cname1} />
            </>
          )}

          {!IS_GLOBAL && (
            <>
              CNAME1
              <span className="app-text-fg-low ml-2">
                ( {clientI18n('customDomain.cname.alibaba')} )
              </span>
              : <CopyableText text={cname1} /> <br />
              CNAME2
              <span className="app-text-fg-low ml-2">
                ( {clientI18n('customDomain.cname.otherCloud')} )
              </span>
              : <CopyableText text={cname2} />
              <br />
              CNAMEX
              <span className="app-text-fg-low ml-2">
                ( {clientI18n('customDomain.cname.HK')} )
              </span>
              : <CopyableText text={cnameX} />
            </>
          )}
        </div>
      )}
    </div>
  );
}
